import { CANDIDATES_FILTERS_INITIAL_VALUES } from 'features/candidate/consts/filters'

export const SENT_JOB_INVITES_FILTERS_INITIAL_VALUES = {
  job: null,
  receiver_profile: {
    ...CANDIDATES_FILTERS_INITIAL_VALUES,
  },
}
